export const container = `relative w-full overflow-hidden grow`;
